import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { 
	AppDispatch,
	RootState, 
} from '@/store/store';

import {
	productSetProductFilters,
	productSetProductFilterCustomOptions,
} from '@/actions/product';

import { FilterOptionProps } from '@/constants/filters';
import { GalleryFilterKeys } from '@/constants/gallery';


const useFilters = (filterKey: GalleryFilterKeys, initialFilters: Record<string, any> = {}) => {

	// Dispatch
	const dispatch = useDispatch<AppDispatch>();
	
	// Access Redux state
	const filtersRedux = useSelector((state: RootState) => state.product.filters[filterKey]);
	const filtersCustomOptionsRedux = useSelector((state: RootState) => state.product.filtersCustomOptions[filterKey]);
	const filtersNameValueRedux = useSelector((state: RootState) => state.product.nameSearchValue);

	// Local state for hydration handling
	const [hydratedFilters, setHydratedFilters] = useState<Record<string, any>>({});
	const [hydratedFiltersCustomOptions, setHydratedFiltersCustomOptions] = useState<Record<string, FilterOptionProps[]>>({});
	const [hydratedFiltersPending, setHydratedFiltersPending] = useState<boolean>(true);
	const [hydratedFiltersNameValue, setHydratedFiltersNameValue] = useState<string>('');

	// Methods
	const setFilters = useCallback((newFilters: Record<string, any>) => {

		dispatch(productSetProductFilters({
			key: filterKey,
			value: newFilters,
		}));

	}, [ dispatch, filterKey ]);

	const setFiltersCustomOptions = useCallback((newFiltersOptions: Record<string, FilterOptionProps[]>) => {
		
		dispatch(productSetProductFilterCustomOptions({
			key: filterKey,
			value: newFiltersOptions,
		}));

	}, [ dispatch, filterKey ]);
  
	// Effects
	useEffect(() => {
		setHydratedFilters(filtersRedux || {});
		setHydratedFiltersPending(false);
	}, [ filtersRedux ]);

	useEffect(() => {
		setHydratedFiltersCustomOptions(filtersCustomOptionsRedux || {});
	}, [ filtersCustomOptionsRedux ]);

	useEffect(() => {
		setHydratedFiltersNameValue(filtersNameValueRedux || '');
	}, [ filtersNameValueRedux ]);

	return {
		filters: hydratedFilters,
		filtersPending: hydratedFiltersPending,
		filtersCustomOptions: hydratedFiltersCustomOptions,
		filtersNameValue: hydratedFiltersNameValue,
		setFilters,
		setFiltersCustomOptions,
	};
};
export default useFilters;